import { render } from "./SocialCard.vue?vue&type=template&id=4c849c00&scoped=true"
import script from "./SocialCard.vue?vue&type=script&lang=js"
export * from "./SocialCard.vue?vue&type=script&lang=js"

import "./SocialCard.vue?vue&type=style&index=0&id=4c849c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c849c00"]])

export default __exports__